import { createFileRoute, redirect } from '@tanstack/react-router'
import { findCachedVTOLook, vtoLook } from '@/lib/queries/vto-looks'
import { decodeId, encodeId } from '@/lib/short-uuid'
import { VTODetailPage } from '@/features/workspaces/vto/detail'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/vto/$lookId'
)({
  params: {
    parse: (rawParams: { lookId: string }) => {
      try {
        return { lookId: decodeId(rawParams.lookId) }
      } catch {
        return { lookId: rawParams.lookId }
      }
    },
    stringify: (params: { lookId: string }) => ({
      lookId: encodeId(params.lookId),
    }),
  },
  loader: async ({ context, params }) => {
    const { queryClient } = context

    try {
      // Check infinite cache first (for optimistic updates)
      const cachedData = findCachedVTOLook(
        queryClient,
        params.workspaceId,
        params.lookId
      )

      // ALWAYS ensure the query is properly initialized with its queryFn
      // This is critical for invalidateQueries to work later
      const queryOptions = vtoLook.findOne(params.lookId)

      // Only seed if no data exists yet (don't overwrite fresher data from realtime refetch)
      if (cachedData && !queryClient.getQueryData(queryOptions.queryKey)) {
        queryClient.setQueryData(queryOptions.queryKey, cachedData)
      }

      const data = await queryClient.query({
        ...queryOptions,
        staleTime: 'static',
      })

      if (!data || data.workspace_id !== params.workspaceId) {
        throw new Error('Invalid VTO Look')
      }
    } catch {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/vto',
        params: { orgId: params.orgId, workspaceId: params.workspaceId },
        replace: true,
      })
    }
  },
  component: VTODetailPage,
})
